<template>
  <CardGrid v-if="showEvents" :data="data"> </CardGrid>
  <Container class="section-spacing" v-else>
    <div class="space-y-20px">
      <Heading :headingTag="'h2'" :style="'h2'" bottomSpacing>
        {{ data.title }}
      </Heading>
      <Paragraphs
        isHighlight
        :text="'<p>No webinars are currently scheduled. Please check back soon or watch a previous webinar below.</p>'"></Paragraphs>
    </div>
  </Container>
</template>

<script>
import Container from "../Atoms/Container.vue";
import CardGrid from "./CardGrid.vue";
import Heading from "../Atoms/Heading.vue";
import Paragraphs from "../Atoms/ParagraphsNew.vue";

export default {
  components: {
    Container,
    CardGrid,
    Heading,
    Paragraphs,
  },

  props: {
    events: {
      type: Object,
      required: false,
    },
  },

  setup(props) {
    const data = {
      title: "Register for a live webinar",
      numberOfColumns: "3",
      backgroundColor: "white",
      cards: props.events,
    };

    const showEvents = props.events == null ? false : true;

    return {
      data,
      showEvents,
    };
  },
};
</script>

<style></style>
